export const isSafari = () =>
  typeof navigator !== 'undefined' &&
  navigator.vendor === 'Apple Computer, Inc.' &&
  !(window as Window & { chrome?: unknown }).chrome;
